var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-menu-wrapper", class: { active: _vm.menuOpen } },
    [
      _c("profile-image", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.menuOpen,
            expression: "menuOpen"
          }
        ]
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.menuOpen,
                expression: "menuOpen"
              }
            ],
            staticClass: "menu-container",
            class: { expanded: _vm.isMenuExpanded }
          },
          [_c("dynamic-link", { attrs: { type: _vm.currentMenuComponent } })],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c20d0de", { render: render, staticRenderFns: staticRenderFns })
  }
}